import { fetcher } from '@commenda/utils';

export type TCreateCompanyHandler = {
  name: string;
  email: string;
  avatar?: string;
  meetingCalendarLink?: string;
};

export async function createCompanyHandler(data: TCreateCompanyHandler) {
  try {
    const res = await fetcher('user', {
      method: 'POST',
      body: data,
    });

    return res;
  } catch (err) {
    console.error(err);
    throw err;
  }
}
